
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/screener",
      function () {
        return require("private-next-pages/screener.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/screener"])
      });
    }
  